import { FaPhoneSlash, FaVideo } from "react-icons/fa";

import { useCalls } from "../CallsContext";
import { describeCall, sameId, unansweredOutcome } from "../callsModel.mjs";
import "../calls.css";

const timeLabel = (value) => {
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? ""
    : date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
};

export default function CallSystemRow({ message }) {
  const calls = useCalls();
  const call = message.context_data?.call;
  const threadId = message.thread_id;
  const userId = calls?.controller.getContext().userId;
  const outgoing = sameId(call?.started_by_id ?? message.sender?.id, userId);
  // Participant states say who declined; end_reason alone can report a decline as unanswered.
  const outcome = ["no_answer", "declined", "cancelled"].includes(call?.end_reason)
    ? unansweredOutcome(call, userId)
    : null;
  const unanswered = Boolean(outcome);
  const missed = outcome === "missed";
  const kind = call?.kind === "audio" ? "voice" : "video";
  const Kind = kind === "voice" ? "Voice" : "Video";
  const text =
    outcome === "declined"
      ? outgoing
        ? `${Kind} call · Declined`
        : `Declined ${kind} call`
      : missed
        ? outgoing
          ? `${Kind} call · No answer`
          : `Missed ${kind} call`
        : message.content || describeCall(call);
  const Icon = unanswered ? FaPhoneSlash : FaVideo;
  const time = timeLabel(message.created_at);
  return (
    <div className="calls-system-row">
      <div className={`calls-system-pill ${missed && !outgoing ? "is-missed" : ""}`}>
        <span className="calls-system-icon" aria-hidden="true">
          <Icon />
        </span>
        <span className="calls-system-text">
          <span>{text}</span>
          {time && <time dateTime={message.created_at}>{time}</time>}
        </span>
        {calls && threadId && (
          <button
            type="button"
            className="calls-system-action"
            onClick={() => calls.controller.openPreview(threadId)}
          >
            <FaVideo aria-hidden="true" />
            Call back
          </button>
        )}
      </div>
    </div>
  );
}
